document.addEventListener("click", (e) => {
  const btn = e.target.closest("[data-spoil-yourself]");
  if (!btn) return;

  e.preventDefault();

  const card =
    btn.closest("product-card") ||
    btn.closest(".product-card") ||
    btn.closest("[data-product-id]") ||
    btn.closest("li") ||
    document;

  // 1) BEST: submit the actual add-to-cart form inside this card
  const addForm = card.querySelector('form[action^="/cart/add"]');
  if (addForm) {
    if (typeof addForm.requestSubmit === "function") {
      addForm.requestSubmit();
    } else {
      const submitBtn = addForm.querySelector('[type="submit"]') || addForm.querySelector('button');
      if (submitBtn) submitBtn.click();
      else addForm.submit();
    }
    return;
  }

  // 2) Trigger theme quick add button if present
  const quickAddTrigger =
    card.querySelector("[data-quick-add-button]") ||
    card.querySelector("quick-add-component button") ||
    card.querySelector("add-to-cart-component button") ||
    card.querySelector("button[name='add']");

  if (quickAddTrigger) {
    quickAddTrigger.click();
    return;
  }

  // 3) Fallback: go to product page
  const url = btn.getAttribute("data-product-url");
  if (url) window.location.href = url;
});

// Sync size dropdown → hidden variant ID input
document.addEventListener("change", (e) => {
  const select = e.target.closest("[data-product-card-size]");
  if (!select) return;

  const card =
    select.closest("product-card") ||
    select.closest(".product-card") ||
    document;

  const hiddenInput = card.querySelector('input[name="id"]');
  if (!hiddenInput) return;

  const selectedOption = select.options[select.selectedIndex];
  if (selectedOption && selectedOption.dataset.variantId) {
    hiddenInput.value = selectedOption.dataset.variantId;
  }
});
